// extracted by mini-css-extract-plugin
export var table = "_xu-0";